package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.EvenOdd
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.ScreenPort: ImageVector
    get() {
        if (_screenPort != null) {
            return _screenPort!!
        }
        _screenPort = Builder(name = "ScreenPort", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
                viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd) {
                    moveTo(10.0f, 18.5f)
                    lineTo(8.136f, 18.5f)
                    curveTo(7.283f, 18.5f, 6.591f, 17.808f, 6.591f, 16.955f)
                    lineTo(6.591f, 3.045f)
                    curveTo(6.591f, 2.192f, 7.283f, 1.5f, 8.136f, 1.5f)
                    lineTo(8.136f, 1.5f)
                    lineTo(15.864f, 1.5f)
                    curveTo(16.717f, 1.5f, 17.409f, 2.192f, 17.409f, 3.045f)
                    lineTo(17.409f, 16.955f)
                    curveTo(17.409f, 17.808f, 16.717f, 18.5f, 15.864f, 18.5f)
                    lineTo(14.0f, 18.5f)
                    lineTo(14.0f, 20.5f)
                    lineTo(16.0f, 20.5f)
                    lineTo(16.0f, 22.5f)
                    lineTo(8.0f, 22.5f)
                    lineTo(8.0f, 20.5f)
                    lineTo(10.0f, 20.5f)
                    lineTo(10.0f, 18.5f)
                    close()
                    moveTo(9.682f, 5.364f)
                    lineTo(9.682f, 8.455f)
                    lineTo(10.841f, 8.455f)
                    lineTo(10.841f, 6.523f)
                    lineTo(12.773f, 6.523f)
                    lineTo(12.773f, 5.364f)
                    lineTo(9.682f, 5.364f)
                    lineTo(9.682f, 5.364f)
                    close()
                    moveTo(13.159f, 11.545f)
                    lineTo(13.159f, 13.477f)
                    lineTo(11.227f, 13.477f)
                    lineTo(11.227f, 14.636f)
                    lineTo(14.318f, 14.636f)
                    lineTo(14.318f, 11.545f)
                    lineTo(13.159f, 11.545f)
                    lineTo(13.159f, 11.545f)
                    close()
                    moveTo(8.136f, 3.818f)
                    lineTo(15.864f, 3.818f)
                    lineTo(15.864f, 16.182f)
                    lineTo(8.136f, 16.182f)
                    lineTo(8.136f, 3.818f)
                    lineTo(8.136f, 3.818f)
                    close()
                }
            }
        }
        .build()
        return _screenPort!!
    }

private var _screenPort: ImageVector? = null
